import { render, staticRenderFns } from "./TableRestrictionTypeRatePlanSidebar.vue?vue&type=template&id=40a04070&scoped=true&"
import script from "./TableRestrictionTypeRatePlanSidebar.vue?vue&type=script&lang=js&"
export * from "./TableRestrictionTypeRatePlanSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a04070",
  null
  
)

export default component.exports